<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="SaaS利用情報"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <div>
            <v-container>
              <v-row>
                <v-col class="d-flex flex-row ga-2 justify-end">
                  <v-btn
                    color="primary"
                    @click="modifyMSService"
                    v-permission.admin
                    >変更</v-btn
                  >
                  <v-btn
                    color="primary"
                    @click="delMSService"
                    v-permission.admin
                    >削除</v-btn
                  >
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="VPN/VNコード"
                    :value="
                      saas.saasCommon.vnName
                        ? saas.saasCommon.vnName +
                          ' : ' +
                          saas.saasCommon.vpnVnCode
                        : saas.saasCommon.vpnVnCode
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="Microsoft Peering"
                    :value="saas.msPeeringFlag"
                  />
                </v-col>
              </v-row>
              <template
                v-if="saas.msPeeringInfo && saas.msPeeringInfo.msPeering"
              >
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="NAPTアドレス上限数"
                      :value="saas.msPeeringInfo.msPeering.upperLimitNapt"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="NATアドレス上限数"
                      :value="saas.msPeeringInfo.msPeering.upperLimitNat"
                    />
                  </v-col>
                </v-row>
              </template>
              <v-row>
                <v-col cols="12">
                  <app-label-group label="Salesforce" :value="saas.sfdcFlag" />
                </v-col>
              </v-row>
              <v-row v-if="saas.sfdcInfo && saas.sfdcInfo.sfdc">
                <v-col cols="12">
                  <app-label-group
                    label="NAPTアドレス上限数"
                    :value="saas.sfdcInfo.sfdc.upperLimitNapt"
                  />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { SaaSListEntity } from "@/views/nwSetting/saas/SaaSServiceApplicationList.vue";
import SaaSServiceUsageEdit from "@/modals/saas/SaaSServiceUsageEdit.vue";
import { VueFinalModal } from "vue-final-modal";
import AppModal from "@/components/AppModal.vue";

export default defineComponent({
  name: "SaaSServiceUsageReference",
  components: { AppModal },
  props: {
    /** SaaS設定情報 */
    saas: {
      type: Object as PropType<SaaSListEntity>,
      required: true,
    },
    /** 設定追加・変更時、使用する排他キー */
    saasKeyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  methods: {
    /** サービス設定変更画面表示 */
    async modifyMSService() {
      await this.$modal.show(SaaSServiceUsageEdit, {
        saas: this.saas,
        saasKeyId: this.saasKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    async delMSService() {
      await this.$confirm("SaaS利用設定を削除します。よろしいですか？");

      /** APIによるSaaS利用設定削除処理 */
      await this.$api.saas.delete({
        vpnVnCode: this.saas.saasCommon.vpnVnCode,
        saasKeyId: this.saasKeyId,
      });

      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
